const financeTemplate = `
 <div className="mt-2">
  <p><strong style="color: rgb(16, 65, 130);">Contexte :</strong></p>
  <ul>
    <li>Acteur majeur du secteur pétrolier, le Groupe XXX offre à l’ensemble de ses points de vente, via XXX
      (filiale), des solutions …
    </li>
    <li>Intervention au sein de la Direction Financière Groupe, dans le cadre du projet de structuration des
      budgets France
    </li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Périmètre :</strong></p>
  <ul>
    <li>XX Pays - XXX salariés – XX usines – typologie(s) de population(s) (sièges, cadre, ETAM…)</li>
    <li>Département finance de XX personnes – Reporting au DRH Monde</li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Objectifs :</strong></p>
  <ul>
    <li>Objectif 1</li>
    <li>Objectif 2</li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Réalisations :</strong></p>
  <ul>
    <li>Superviser les travaux du service comptable</li>
    <li>Assurer la fiabilité et produire les comptes du Groupe</li>
    <li>Audit de la comptabilité statutaire et refonte du reporting</li>
    <li>Mise en conformité sociale et légale</li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Résultats :</strong></p>
  <ul>
    <li>Contrôle physique des immobilisations corporelles pour 80% de la VNC du groupe</li>
    <li>Validation des comptes de la filiale belge et obtention de la remise du rapport des comptes 2016 par
      PWC
    </li>
  </ul>
</div>
`

export {financeTemplate}